import React, { useState, useEffect } from "react";
import {
  ManagePlanLayout,
  FieldDropSide,
  FormLeaveGuard,
  DatePicker,
  MultiSelectDropdown,
} from "../../../../components";
import * as Yup from "yup";
import { Form } from "react-bootstrap";
import { isEmpty } from "lodash";
import { Field, Formik } from "formik";
import {
  usDateFormat,
  errors,
  OPTIONS_DATA_MAPPER,
  toOptionValuesFromMapper,
  toMultiSelectValueById,
} from "../../../../utils";

const initialValues = {};

const AddRestrictions = (props) => {
  const {
    fields,
    restrictions,
    setRestrictions,
    dataChangeIndex,
    edit,
    setEdit,
    data,
    isInnerFormDirty,
    setIsInnerFormDirty,
    addRestrictionClick,
    setTabGrey,
  } = props;

  const formValues = {
    [fields.effectiveStartDate]: edit ? data.effectiveStartDate : null,
    [fields.effectiveEndDate]: edit ? data.effectiveEndDate : null,
    [fields.applicableTypes]: edit ? data.applicableTypes : [],
  };
  const schema = Yup.object().shape({
    effectiveStartDate: Yup.date().required("TDI081 : Required").nullable(),
    effectiveEndDate: Yup.date()
      .required("TDI082 : Required")
      .min(
        Yup.ref("effectiveStartDate"),
        `TDI084 : ${errors.restrictionsPlan.overlapError}`
      )
      .nullable(),
    applicableTypes: Yup.array().required("TDI083 : Required").nullable(),
  });

  const [showDirtyCheckModal, setShowDirtyCheckModal] = useState(false);

  useEffect(() => {
    return () => setIsInnerFormDirty(false);
  }, []);

  const onFormToggle = () => {
    if (isInnerFormDirty) {
      setShowDirtyCheckModal(true);
    } else {
      addRestrictionClick();
    }
  };

  const handleConfirmClick = () => {
    addRestrictionClick();
  };

  const handleCancelClick = () => {
    setShowDirtyCheckModal(false);
  };

  const onFormSubmit = (values) => {
    if (edit) {
      setRestrictions(
        restrictions.map((item, idx) => {
          if (idx == dataChangeIndex) {
            return (item = {
              ...item,
              effectiveStartDate: values.effectiveStartDate,
              effectiveEndDate: values.effectiveEndDate,
              applicableTypes: values.applicableTypes,
            });
          } else return item;
        })
      );
    } else {
      setRestrictions([...restrictions, values]);
    }
    setEdit(false);
    addRestrictionClick();
  };

  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      onClick: () => {
        setEdit(false);
        onFormToggle();
      },
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
    },
  ];

  return (
    <Formik
      initialValues={{
        ...initialValues,
        ...formValues,
      }}
      onSubmit={onFormSubmit}
      enableReinitialize
      validationSchema={schema}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({
        handleChange,
        setFieldValue,
        handleSubmit,
        values,
        dirty,
        ...rest
      }) => {
        if (isInnerFormDirty !== dirty) {
          setIsInnerFormDirty(dirty);
        }
        const onDaySelected = (fieldName, value) => {
          setFieldValue(fieldName, value);
        };
        return (
          <Form
            autoComplete="off"
            className="h-100"
            onSubmit={handleSubmit}
            validated={!isEmpty(rest.errors)}
          >
            <ManagePlanLayout buttons={buttons} layoutHeader={"Restriction"}>
              <div className="line-separator" />
              <Field
                size="smd"
                name={fields.effectiveStartDate}
                label={"Effective Start Date"}
                value={usDateFormat(values[fields.effectiveStartDate])}
                onClear={() => onDaySelected(fields.effectiveStartDate, "")}
                isDatePicker
                isRequired
                validate={(value) =>
                  ["", undefined, null, "Select One"].includes(value)
                    ? "Requiredww"
                    : null
                }
                popupContent={
                  <DatePicker
                    onDayClick={(value) => {
                      setTabGrey(1);
                      onDaySelected(fields.effectiveStartDate, value);
                    }}
                    value={usDateFormat(values[fields.effectiveStartDate])}
                  />
                }
                component={FieldDropSide}
              />
              <Field
                size="smd"
                name={fields.effectiveEndDate}
                label={"Effective End Date"}
                value={usDateFormat(values[fields.effectiveEndDate])}
                onClear={() => onDaySelected(fields.effectiveEndDate, "")}
                isDatePicker
                isRequired
                popupContent={
                  <DatePicker
                    onDayClick={(value) => {
                      setTabGrey(1);
                      onDaySelected(fields.effectiveEndDate, value);
                    }}
                    value={usDateFormat(values[fields.effectiveEndDate])}
                  />
                }
                component={FieldDropSide}
              />

              <Field
                label={"Applicable Types"}
                size="smd"
                name={fields.applicableTypes}
                value={toMultiSelectValueById(
                  values[fields.applicableTypes],
                  toOptionValuesFromMapper(
                    OPTIONS_DATA_MAPPER.TEMP_APPLICABLE_TYPES
                  )
                )}
                isMultiSelect
                isRequired
                popupContent={
                  <MultiSelectDropdown
                    label="Select applicable types"
                    name={fields.applicableTypes}
                    onSelect={(value) => {
                      setTabGrey(1);
                      setFieldValue(fields.applicableTypes, value);
                    }}
                    value={values[fields.applicableTypes]}
                    options={toOptionValuesFromMapper(
                      OPTIONS_DATA_MAPPER.TEMP_APPLICABLE_TYPES
                    )}
                  />
                }
                component={FieldDropSide}
              />
            </ManagePlanLayout>
            <FormLeaveGuard
              showModal={showDirtyCheckModal}
              handleConfirmClick={handleConfirmClick}
              handleCancelClick={handleCancelClick}
            />
          </Form>
        );
      }}
    </Formik>
  );
};

export default AddRestrictions;
